import { render } from "./request_portal.html?vue&type=template&id=65d811fc&external"
import script from "./request_portal.js?vue&type=script&lang=js&external"
export * from "./request_portal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__